/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {useRouter} from 'next/router';
import moment from 'moment-timezone';
import {truncate} from 'lodash';

import Link from '../../components/Link';
import FacePile from '../../components/FacePile';
import {useAnalytics} from '../../hooks';

const MAX_TITLE_LENGTH = 200;

const QuestionCard = ({question, tag}) => {
  const {tracker} = useAnalytics();
  const router = useRouter();
  const url = `/questions/${question.id}/${question.slug}`;

  const handleClick = () => {
    tracker.hubClickCard({type: 'questions', tag: tag.id, slug: question.slug});
    router.push(url);
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer py-3 px-4 mb-2 border border-gray-200 rounded-lg text-sm font-semibold leading-none hover:border-gray-300 transition duration-50 flex justify-between"
    >
      <div>
        <h3 className="inline text-base">
          <Link href={url}>
            {truncate(question.data.title, {length: MAX_TITLE_LENGTH})}
          </Link>
        </h3>
        {question.latest_comment && (
          <span className="text-sm font-medium text-gray-500 pl-2">
            Updated
            {' '}
            {moment(question.latest_comment).fromNow()}
          </span>
        )}
      </div>

      <FacePile faces={question.commenters} small className="ml-5 mr-2" />
    </div>
  );
};

export default QuestionCard;
